@media screen and (max-width: 979px) {
  .range-node-header {
    text-align: center;
  }
}

.range-node-header__prev-level-title {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: #626469;
}

:host(:not([dir="rtl"])) .range-node-header__prev-level-title {
  margin: 0 0 0 32px;
}

:host([dir="rtl"]) .range-node-header__prev-level-title {
  margin: 0 32px 0 0;
}

@media screen and (max-width: 979px) {
  :host(:not([dir="rtl"])) .range-node-header__prev-level-title {
    margin-left: 0;
  }

  :host([dir="rtl"]) .range-node-header__prev-level-title {
    margin-right: 0;
  }
}